<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-unit" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">QR Code</h5>
      </div>
      <div id="modal-body" class="p-5 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <div class="flex flex-col items-center justify-center space-y-4">
          <img :src="qrCode.image" alt="QR Code" class="w-64 h-auto" />
          <h1 class="text-center text-xl font-bold text-primary">Bank {{ qrCode.name }}</h1>
        </div>
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white" @click="closeModal" />
          <SubmitButton id="submit" button_name="Lanjut konfirmasi pembayaran" button_class="mx-1 bg-primary hover:bg-hover-primary text-white"
            @click="submitUnit" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';

export default {
  name: "ModalViewQrCode",
  props: {
    qrCode: {
      type: String,
      default: null,
    }
  },
  components: {
    SubmitButton
  },
  data() {
    return {
      showModal: true,
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitUnit() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin sudah menunjukkan QR Code pembayaran?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.$emit('submit', true);
          this.closeModal();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan satuan unit', life: 3000 });
        }
      });
    },
  }
}
</script>